module.exports = __webpack_public_path__ + "img/LightSpeaker.fa7ee7a0.png";